import { z } from "zod";
/** Revelação auditada de campo sensível (FASE-06-T27). */
export const revealEmployeeFieldSchema = z.object({
    field: z.enum(["cpf", "bankAccount", "salaryAmount"]),
});
//# sourceMappingURL=reveal-employee-field.js.map